import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  payments: [],
  posDetails: [],
  fopDetails: [],
  historyDetails: [],
  loading: false,
  addFop: {
    data: [],
    status: null,
  },
  addPos: {
    data: [],
    status: null,
  },
  affectedItems: [],
  fopAffectedItems: [],
};

const paymentSlice = createSlice({
  name: "paymentCatalogue",
  initialState,
  reducers: {
    fetchPayment: (state, action) => {
      state.loading = true;
    },
    fetchPaymentSuccess: (state, action) => {
      state.payments = action.payload;
      state.loading = false;
    },
    fetchPaymentFailure: (state, action) => {
      state.loading = false;
    },

    addNewMarket: (state) => {
      state.loading = true;
    },
    addNewMarketSuccess: (state, action) => {
      state.loading = false;
      state.payments = Array.isArray(state.payments)
        ? [...state.payments, action.payload]
        : [action.payload]; // Add the new market to the payments list
    },
    addNewMarketFailure: (state) => {
      state.loading = false;
    },
    putPayment: (state) => {
      state.loading = true;
    },
    putPaymentSuccess: (state, action) => {
      state.loading = false;
      state.payments = action.payload;
    },
    putPaymentFailure: (state) => {
      state.loading = false;
    },
    fetchPos: (state, action) => {
      state.loading = true;
    },
    fetchPosSuccess: (state, action) => {
      state.posDetails = action.payload;
      state.loading = false;
    },
    fetchPosFailure: (state, action) => {
      state.loading = false;
    },
    fetchFop: (state, action) => {
      state.loading = true;
    },
    fetchFopSuccess: (state, action) => {
      state.fopDetails = action.payload;
      state.loading = false;
    },
    fetchFopFailure: (state, action) => {
      state.loading = false;
    },
    addNewFop: (state) => {
      state.loading = true;
      state.addFop.status = null; // Reset status before adding a new FOP
    },
    addNewFopSuccess: (state, action) => {
      state.loading = false;
      state.addFop.status = "success"; // Set status to success
      if (Array.isArray(state.addFop.data)) {
        state.addFop.data.push(action.payload); // Add the new FOP
      }
    },
    addNewFopFailure: (state) => {
      state.loading = false;
      state.addFop.status = "failure"; // Reset status on failure
    },
    addNewPos: (state) => {
      state.loading = true;
      state.addPos.status = null;
    },
    addNewPosSuccess: (state, action) => {
      state.loading = false;
      state.addPos.status = "success"; // Set status to success
      if (Array.isArray(state.addPos.data)) {
        state.addPos.data.push(action.payload);
      }
    },
    addNewPosFailure: (state) => {
      state.loading = false;
      state.addPos.status = "failure"; // Reset status on failure
    },
    deletePayment: (state, action) => {
      state.loading = true;
    },
    deletePaymentSuccess: (state, action) => {
      state.loading = false;
    },
    deletePaymentFailure: (state, action) => {
      state.loading = false;
    },
    fetchAffectedItems: (state, action) => {
      state.loading = true;
    },
    fetchAffectedItemsSuccess: (state, action) => {
      state.affectedItems = action.payload;
      state.loading = false;

    },
    fetchAffectedItemsFailure: (state, action) => {
      state.loading = false;
    },
    SetAffectedItems: (state, action) => {
      state.affectedItems = [];
    },
    deletePOS: (state, action) => {
      state.loading = true;
    },
    deletePOSSuccess: (state, action) => {
      state.loading = false;
    },
    deletePOSFailure: (state, action) => {
      state.loading = false;
    },
    fetchFopAffectedItems: (state, action) => {
      state.loading = true;
    },
    fetchFopAffectedItemsSuccess: (state, action) => {
      state.fopAffectedItems = action.payload;
      state.loading = false;
    },
    fetchFopAffectedItemsFailure: (state, action) => {
      state.loading = false;
    },
    deleteFOP: (state, action) => {
      state.loading = true;
    },
    deleteFOPSuccess: (state, action) => {
      state.loading = false;
    },
    deleteFOPFailure: (state, action) => {
      state.loading = false;
    },
    fetchHistory: (state, action) => {
      state.loading = true;
    },
    fetchHistorySuccess: (state, action) => {
      state.historyDetails = action.payload;
      state.loading = false;
    },
    fetchHistoryFailure: (state, action) => {
      state.loading = false;
    },
  },
});

export const {
  fetchPayment,
  fetchPaymentSuccess,
  fetchPaymentFailure,
  addNewMarket,
  addNewMarketSuccess,
  addNewMarketFailure,
  putPayment,
  putPaymentSuccess,
  putPaymentFailure,
  fetchPos, fetchPosSuccess, fetchPosFailure,
  fetchFop,
  fetchFopSuccess,
  fetchFopFailure,
  addNewFop,
  addNewFopSuccess,
  addNewFopFailure,
  addNewPos,
  addNewPosSuccess,
  addNewPosFailure,
  deletePayment,
  deletePaymentSuccess,
  deletePaymentFailure,
  fetchAffectedItems,
  fetchAffectedItemsSuccess,
  fetchAffectedItemsFailure,
  deletePOS,
  deletePOSSuccess,
  deletePOSFailure,
  fetchFopAffectedItems,
  fetchFopAffectedItemsSuccess,
  fetchFopAffectedItemsFailure,
  deleteFOP,
  deleteFOPSuccess,
  deleteFOPFailure,
  SetAffectedItems,
  fetchHistory,
  fetchHistorySuccess,
  fetchHistoryFailure,
} = paymentSlice.actions;

export default paymentSlice.reducer;
